import { combineReducers } from 'redux';

import plan from './planReducer';
import builder from './builderReducer';
import loadStatus from './loadStateReducer';
import gwtStatus from './gwtStateReducer';

export default combineReducers({
  plan,
  builder,
  loadStatus,
  gwtStatus,
});
